export default __webpack_public_path__ + "static/broadcastImg4-bb068ff5449ffb2e54dc9cde7b835239.webp";